/* eslint-disable no-fallthrough */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import snakeCase from 'lodash/snakeCase';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
// import { putErrorNotification } from '@wix/da-shared-react/pkg/utils/saga';
import { request, isApiError } from '../../xhr';
// import { ConfigSelectors } from '@wix/da-shared-react/pkg/config';
import ddt from '@wix/da-ddt';
import { updateModule, fetchModuleEndpoint, fetchModuleEndpointSuccess, fetchModuleEndpointError, fetchModuleSuccess } from '../actions/modules';
import { getModuleName, getModuleVersion } from '../selectors/modules';
import { getGruser } from '../selectors/gruser';
// deviation_gruser TODO: use from the lib
const configReduxKey = '@@config';
const getConfigKey = (name)=>(state)=>{
        var _state_configReduxKey;
        return (_state_configReduxKey = state[configReduxKey]) === null || _state_configReduxKey === void 0 ? void 0 : _state_configReduxKey[name];
    };
function* postModuleEndpoint(endpoint, params) {
    return yield call(request, {
        method: 'post',
        url: `/module/${endpoint}`,
        data: transformParamNames(params)
    });
}
function* getModuleEndpoint(endpoint, params) {
    return yield call(request, {
        method: 'post',
        url: `/module/${endpoint}`,
        data: transformParamNames(params)
    });
}
const isModuleResponse = (response)=>response && response.hasOwnProperty('id') && response.hasOwnProperty('version') && response.hasOwnProperty('moduleData');
export function* runModuleInitActions(moduleResponse) {
    // Duck typing
    if (!isModuleResponse(moduleResponse)) {
        return;
    }
    yield put(fetchModuleSuccess(moduleResponse));
}
// I hate this
function transformParamNames(params) {
    return Object.keys(params).reduce((transformedParams, key)=>{
        switch(key){
            case 'moduleId':
            case 'folderId':
            case 'countryId':
                // convert to lovercase
                transformedParams[key.toLowerCase()] = params[key];
                break;
            case 'sourceType':
            case 'viewMode':
            case 'slideImageFit':
            case 'sortBy':
            // members:
            case 'rolesFilter':
            // active_members
            case 'displayLimit':
            // custombox
            case 'backgroundType':
            case 'imageDisplayMode':
            case 'imageDeviationid':
            case 'imageTint':
            case 'imageUrl':
            // about module
            case 'dobDay':
            case 'dobMonth':
            case 'dobYear':
            case 'websiteLabel':
            case 'showBadges':
            case 'socialLinks':
            case 'isArtist':
                // convert to snake_case
                transformedParams[snakeCase(key)] = params[key];
                break;
            default:
                transformedParams[key] = params[key];
        }
        return transformedParams;
    }, {});
}
export function* fetchModuleEndpointSaga(action) {
    const { payload } = action;
    const { id, path, method } = payload, data = _object_without_properties(payload, [
        "id",
        "path",
        "method"
    ]);
    const version = yield select(getModuleVersion, id);
    const { username } = yield select(getGruser);
    const moduleType = yield select(getModuleName, id);
    const csrf = yield select(getConfigKey('csrfToken'));
    const fetchEndpoint = method === 'get' ? getModuleEndpoint : postModuleEndpoint;
    const response = yield call(fetchEndpoint, `${moduleType}${path}`, _object_spread_props(_object_spread({}, data), {
        csrf_token: csrf,
        username,
        version,
        moduleId: id
    }));
    if (!response || isApiError(response)) {
        var _response_errorDetails, _response, _response1, _response2;
        const errorDescription = ((_response = response) === null || _response === void 0 ? void 0 : (_response_errorDetails = _response.errorDetails) === null || _response_errorDetails === void 0 ? void 0 : _response_errorDetails.Form) || ((_response1 = response) === null || _response1 === void 0 ? void 0 : _response1.details) || ((_response2 = response) === null || _response2 === void 0 ? void 0 : _response2.errorDescription);
        ddt.log(`modules`, `fetch action error`, `${errorDescription}`);
        // yield putErrorNotification(errorDescription);
        yield put(fetchModuleEndpointError({
            id,
            path,
            errorDescription
        }));
        yield put(updateModule({
            id,
            moduleMeta: {
                isFetching: false
            }
        }));
        return;
    }
    if (isModuleResponse(response)) {
        // update module data in the store
        yield runModuleInitActions(response);
    } else {
        // endpoint does not return a module response, hence, no module version gets updated
        // module version is used as memoization key for many hooks, so if no version
        ddt.log(`modules`, `save endpoint does not return a module response`, {
            id,
            path,
            response
        });
    }
    yield put(fetchModuleEndpointSuccess({
        id,
        response,
        path
    }));
}
export default function* rootModulesSaga() {
    yield all([
        takeEvery(fetchModuleEndpoint, fetchModuleEndpointSaga)
    ]);
}
